import { atom } from 'jotai';

import { ScheduleType } from './Scheduler.constants';

export const schedulerShowPopupState = atom(false);

export const schedulerTypeState = atom<ScheduleType>(ScheduleType.Day);
